import Redirect from './Redirect.component';

export default Redirect;
